import * as React from "react";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { ChronologyListRow } from "@/views/chronology-list/components/row";
import { ChronologyListTableHeader } from "@/views/chronology-list/components/tableHeader";
import TopBarProgress from "react-topbar-progress-indicator";
import { Loader } from "@/components/ui/loader";
import { useGetTransactionsQuery } from "@/api/transactions";
import { Transaction, TxType } from "@/types/transaction";

const emptyList: Transaction[] = [];

export const ChronologyListView: React.FC = () => {
  const { data: transactions = emptyList, isLoading } = useGetTransactionsQuery({
    perPage: 5,
    txType: TxType.CHRONOLOGY,
  });

  return (
    <div className="mt-5 rounded-xl bg-white p-5 shadow-md">
      {isLoading && <TopBarProgress />}
      <h3 className="mb-5 text-2xl font-semibold">Recent Chronology</h3>
      <div className="w-full">
        <div className="relative overflow-hidden rounded-xl border bg-white shadow-sm">
          <div className="overflow-x-auto">
            {isLoading ? (
              <Loader />
            ) : (
              <Table>
                <ChronologyListTableHeader />
                <TableBody>
                  {transactions.length ? (
                    transactions.map(transaction => (
                      <ChronologyListRow key={transaction.tx_id} transaction={transaction} />
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} className="h-24 text-center text-muted-foreground">
                        No chronology entries found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
